import { Routes } from "@angular/router";
import { ClientAdminComponent } from "./products/features/client-admin/client-admin.component";
import { PlanAdminComponent } from "./products/features/plan-admin/plan-admin.component";
import { ProductCategoryAdminComponent } from "./products/features/product-category-admin/product-category-admin.component";
import { ProductAdminComponent } from "./products/features/product-admin/product-admin.component";
import { TestingComponent } from "./payment/features/testing/testing.component";
import { SuccessLandingComponent } from "./payment/features/success-landing/success-landing.component";
import { PaymentSummaryComponent } from "./payment/features/payment-summary/payment-summary.component";
import { ProductsMenuComponent } from "./products/features/products-menu/products-menu.component";
import { GlCodeAdminComponent } from "./products/features/gl-code-admin/gl-code-admin.component";
import { PaymentErrorComponent } from "./payment/features/payment-error/payment-error.component";
import { EmptyCartComponent } from "./payment/ui/empty-cart/empty-cart.component";
import { PayWithAchComponent } from "./payment/features/pay-with-ach/pay-with-ach.component";
import { PayWithBtAchComponent } from "./payment/features/pay-with-bt-ach/pay-with-bt-ach.component";
import { AccountVerificationComponent } from "./payment/features/account-verification/account-verification.component";
import { PayWithBtPaypalComponent } from "./payment/features/pay-with-bt-paypal/pay-with-bt-paypal.component";
import { PayWithBtCreditCardComponent } from "./payment/features/pay-with-bt-credit-card/pay-with-bt-credit-card.component";
import { OnboardSuccessfulComponent } from "./payment/features/onboard-successful/onboard-successful.component";
import { CanceledLandingComponent } from "./payment/features/canceled-landing/canceled-landing.component";


export const PAYMENT_ADMIN_ROUTES: Routes = [
  {
    path: 'product-menu',
    component: ProductsMenuComponent,
    children: [
      {
        path: 'client-admin',
        component: ClientAdminComponent,
      },
      {
        path: 'plan-admin',
        component: PlanAdminComponent
      },
      {
        path: 'product-category-admin',
        component: ProductCategoryAdminComponent
      },
      {
        path: 'product-admin',
        component: ProductAdminComponent
      },
      {
        path: 'gl-codes-admin',
        component: GlCodeAdminComponent
      },
    ]
  }]

export const PAYMENT_USER_ROUTES: Routes = [  
  {
    path: 'payment-summary',
    component: PaymentSummaryComponent
  },
  {
    path: 'pay-with-paypal',
    component: PayWithBtPaypalComponent
  },
  {
    path: 'pay-with-card',
    component: PayWithBtCreditCardComponent
  },
  {
    path: 'pay-with-ach',
    component: PayWithAchComponent
  },
  {
    path: 'pay-with-bt-ach',
    component: PayWithBtAchComponent
  },
  {
    path: 'bank-account-verification',
    component: AccountVerificationComponent
  },
  {
    path: 'demo',
    component: TestingComponent
  },
  {
    path: 'onboard-success',
    component: OnboardSuccessfulComponent
  },
  {
    path: 'success',
    component: SuccessLandingComponent
  },
  {
    path: 'canceled',
    component: CanceledLandingComponent
  },
  {
    path: 'payment-error',
    component: PaymentErrorComponent
  },

  {
    path: 'empty',
    component: EmptyCartComponent
  }
];